import RequireAuthentication from "../component/require/RequireAuthentication"
import { useNavigate, useParams } from "react-router-dom"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import {
    selectDashboardPatient,
    selectDashboardValueType,
    selectPatientsOfProfessional
} from "../redux/ProfessionalDashboard"
import notNull from "../util/notNull"
import {
    NAVIGATION_VIEW,
    NavigationPaths
} from "../navigation/NavigationController"

function RedirectDataView() {
    const { patient, valueType } = useParams()
    const patients = useAppSelector(selectPatientsOfProfessional)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (
            patient !== undefined &&
            valueType !== undefined &&
            notNull(patients)
        ) {
            const toBeSelectedPatient = patients.find((p) => p.id === patient)
            if (toBeSelectedPatient === undefined) {
                alert("Patient:in konnte nicht gefunden werden.")
                navigate(
                    NavigationPaths[NAVIGATION_VIEW.PATIENT_SELECTION_VIEW].path
                )
                return
            }
            dispatch(selectDashboardPatient(toBeSelectedPatient))
            dispatch(selectDashboardValueType(Number(valueType)))
            navigate(NavigationPaths[NAVIGATION_VIEW.PATIENT_DETAIL_VIEW].path)
        }
    }, [patient, valueType, patients])

    return (
        <RequireAuthentication>
            <></>
        </RequireAuthentication>
    )
}

export default RedirectDataView
